import { Box, SxProps } from '@mui/material';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import getRatio from '@/utils/getRatio';

type Props = {
  src: string;
  ratio?: string;
  alt?: string;
  disabledEffect?: boolean;
  effect?: 'blur' | 'opacity';
  objectFit?: 'cover' | 'contain';
  overComponent?: React.ReactNode;
  sx?: SxProps;
  onClick?: () => void;
  loading?: string;
};

export default function Image({ ratio, disabledEffect = false, effect = 'blur', objectFit, overComponent, sx, ...other }: Props) {
  const imageComponent = (
    <Box
      component={LazyLoadImage}
      wrapperClassName="wrapper"
      effect={disabledEffect ? undefined : effect}
      placeholderSrc="https://treedis-public.s3-accelerate.amazonaws.com/assets/image-placeholder.svg"
      sx={{ width: 1, height: 1, objectFit }}
      {...other}
    />
  );

  if (ratio) {
    return (
      <Box
        component="span"
        sx={{
          width: 1,
          lineHeight: 1,
          display: 'block',
          overflow: 'hidden',
          position: 'relative',
          pt: getRatio(ratio),
          '& .wrapper': {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            lineHeight: 0,
            position: 'absolute',
            backgroundSize: 'cover !important',
          },
          ...sx,
        }}
      >
        {imageComponent}
        {overComponent}
      </Box>
    );
  }

  return (
    <Box
      component="span"
      sx={{
        lineHeight: 0,
        display: 'block',
        overflow: 'hidden',
        '& .wrapper': { width: 1, height: 1, backgroundSize: 'cover !important' },
        ...sx,
      }}
    >
      {imageComponent}
    </Box>
  );
}
